// Project Imports
import { REACT_APP_API_URL_ORG } from 'config';
import apiEndpoint from 'core/common/apiEndPoints';
import axiosInstance from 'providers/axiosInstance/axiosInstance';

const fetchOrganization = async (
  setOrganizationList: React.Dispatch<React.SetStateAction<any[]>>
): Promise<void> => {
  try {
    const response = await axiosInstance.get(
      `${REACT_APP_API_URL_ORG}/${apiEndpoint.organization}/?skip_user_permission=true&page=1&page_size=100`
    );
    const responseData = (response.data as any)?.results;
    const data = responseData.map((item) => ({
      label: item.organization_name,
      value: item.unique_id,
    }));
    await setOrganizationList(data);
  } catch (error) {
    console.log(error);
  }
};

export default fetchOrganization;
